
import EventPublisher from "../utils/EventPublisher";
import PublicRequestExecuter from "./requestExecuters/PublicRequestExecuter";
import SecureRequestExecuter from "./requestExecuters/SecureRequestExecuter";
import PublicResponseHandler from "./ResponseHandlers/PublicResponseHandler";
import SecureResponseHandler from "./ResponseHandlers/SecureResponseHandler";
import ActionResultEvents from "../constants/events/ActionResultEvents";


class SessionResponse {

    constructor(
        session,
        memberId,
        authSystemId,
        authSystemName,
        authSystemUserId,
        profileCreated,
        emailVerified,
        smsVerified,
        created,
        updated,
        deleted
    ) {
        this.session = session;
        this.memberId = memberId;
        this.authSystemId = authSystemId;
        this.authSystemName = authSystemName;
        this.authSystemUserId = authSystemUserId;
        this.profileCreated = profileCreated;
        this.emailVerified = emailVerified;
        this.smsVerified = smsVerified;
        this.created = created;
        this.updated = updated;
        this.deleted = deleted;
    }
}

export default class SessionAPIClient {
    constructor() {
        this.createSessionResponseHandler =
            new PublicResponseHandler(
                new Map()
                    .set("SESSION_CREATED", this.onSessionCreated)
                    .set("INVALID_FB_AUTH_TOKEN", this.onFBAuthTokenIsNotValid));
        this.logoutResponseHandler =
            new SecureResponseHandler(
                new Map()
                    .set("SESSION_DELETED", this.onSessionDeleted));
    }

    createSession(fbUserId, fbAccessToken) {
        PublicRequestExecuter.executePOSTRequest(
            "/api/session_via_fb",
            {},
            {
                "fb_user_id": fbUserId,
                "fb_access_token": fbAccessToken
            },
            {},
            this.createSessionResponseHandler);
    }

    logout() {
        SecureRequestExecuter.executeDELETERequest(
            "/api/private/logout",
            {},
            {},
            {},
            this.logoutResponseHandler
        )
    }

    onSessionDeleted = (responseHeaders, responseBodyContents, dataFromAction) => {
        EventPublisher.publish(ActionResultEvents.FB_LOGOUT_SUCCESS, {});
    };

    onSessionCreated = (responseHeaders, responseBodyContents, dataFromAction) => {
        EventPublisher.publish(
            ActionResultEvents.SESSION_CREATED,
            new SessionResponse(
                responseHeaders.get("session"),
                responseBodyContents["member_id"],
                responseBodyContents["auth_system_id"],
                responseBodyContents["auth_system_name"],
                responseBodyContents["auth_system_user_id"],
                responseBodyContents["profile_created"],
                responseBodyContents["email_verified"],
                responseBodyContents["sms_verified"],
                responseBodyContents["created"],
                responseBodyContents["updated"],
                responseBodyContents["deleted"])
        );
    };

    onFBAuthTokenIsNotValid = (responseHeaders, responseBodyContents, dataFromAction) => {
        EventPublisher.publish(ActionResultEvents.FB_LOGIN_FAILED, {})
    };
}